import { global_content_gallery } from '../../utils/requests/contentstack/contentStackZodSchema';
import { getCloudinaryImageFields } from '../../utils/getCloudinaryItem/getCloudinaryItem';
import type { ContentGalleryProps } from './ContentGallery';

export const contentGallerySchema =
  global_content_gallery.transform<ContentGalleryProps>(data => ({
    contentGalleryHeader: {
      title: data.header?.title ?? '',
      description: data.header?.description ?? '',
      descriptionLinks:
        data.header?.description_links?.map(descriptionLink => {
          return {
            href: descriptionLink.href,
            text: descriptionLink.title,
          };
        }) ?? [],
    },
    layout: data.layout,
    text: data.text,
    topLeftImage: getCloudinaryImageFields({
      alt: data.top_left_image.alt_text,
      cloudinaryField: data.top_left_image.source,
      shouldUseV2: true,
    }),
    topRightImage: getCloudinaryImageFields({
      alt: data.top_right_image.alt_text,
      cloudinaryField: data.top_right_image.source,
      shouldUseV2: true,
    }),
    bottomLeftImage: getCloudinaryImageFields({
      alt: data.bottom_left_image.alt_text,
      cloudinaryField: data.bottom_left_image.source,
      shouldUseV2: true,
    }),
    bottomRightImage: getCloudinaryImageFields({
      alt: data.bottom_right_image.alt_text,
      cloudinaryField: data.bottom_right_image.source,
      shouldUseV2: true,
    }),
  }));
